import { cfarExerciseTrackingMiddleware } from "./trackingMiddleware";

export const middlewares = [cfarExerciseTrackingMiddleware];
